import { FileText } from 'lucide-react';

import { useGetChunk } from '@/api/queries/useGetChunk';
import Drawer from '@/components/molecules/Drawer';
import ChunkDocViewer from '@/screens/Chronos/CaseEditor/components/DocViewer/ChunkDocViewer';

interface ChunkDrawerProps {
  caseId: string | null;
  chunkId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

const ChunkDrawer = ({ caseId, chunkId, isOpen, onClose }: ChunkDrawerProps) => {
  const { data: chunk } = useGetChunk(caseId, chunkId);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} hideCloseButton={true}>
      <div className="flex h-full flex-col">
        {chunk && (
          <>
            {/* Document Name Bar */}
            <div className="border-b border-gray-300 bg-gray-50">
              <div className="flex items-center gap-3 px-4 py-2">
                <div className="flex h-9 items-center gap-2 rounded-md border border-gray-200 bg-white px-3">
                  <div className="flex items-center gap-1.5">
                    <FileText className="h-3.5 w-3.5 text-blue-600" />
                    <span className="text-xs font-medium text-gray-700">Document:</span>
                  </div>
                  <div className="flex h-6 items-center">
                    <span className="max-w-52 truncate text-xs text-gray-700">
                      {chunk.doc?.file?.name || 'Document'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Document Viewer Section */}
            <div className="flex-1 overflow-hidden">
              <ChunkDocViewer
                caseId={caseId}
                docId={chunk.docId}
                chunkId={chunk.id}
                boundingBoxes={chunk.boundingBoxes}
                onClose={onClose}
              />
            </div>
          </>
        )}
      </div>
    </Drawer>
  );
};

export default ChunkDrawer;
